import dennisPic from "@/public/images/artists/dennis.jpg";
import { Artist } from "@/types/types";

export const dennis = {
  id: "282",
  name: "Dennis",
  image: dennisPic,
  description: `Dennis has a rhythmic, talk-sung voice with a laid-back tone and a sharp, percussive delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdennis-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Indie", "Rock"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 67,
      },
      sweetSpot: 59,
    },
  },
} satisfies Artist;
